import HomeContent from '../components/layout/Home/HomeContent';


function HomePage() {
  return (
    <section>
      <HomeContent />
    </section>
  );
}

export default HomePage;